module.exports = __webpack_public_path__ + "static/media/default_logo.da519ff6.png";